(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PANEL_TRANSITION_MS = 350;

    function closePanel(panel, toggle) {
      if (panel.hidden) return;
      panel.style.maxHeight = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          panel.classList.remove('is-open');
          panel.style.maxHeight = '0px';
        });
      });
      window.setTimeout(function () {
        panel.hidden = true;
        panel.style.maxHeight = '';
      }, PANEL_TRANSITION_MS);

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        var openLabel = toggle.querySelector('[data-hc-label-open]');
        var closeLabel = toggle.querySelector('[data-hc-label-close]');
        if (openLabel) openLabel.hidden = false;
        if (closeLabel) closeLabel.hidden = true;
      }
    }

    function closeAllPanels() {
      document.querySelectorAll('[data-hc-panel]').forEach(function (panel) {
        var header = panel.closest('header-custom');
        var toggle = header && header.querySelector('[data-hc-panel-open]');
        closePanel(panel, toggle);
      });
    }

    function openPanel(panel, toggle) {
      panel.hidden = false;
      panel.style.maxHeight = '0px';
      requestAnimationFrame(function () {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        panel.classList.add('is-open');
      });
      window.setTimeout(function () {
        if (panel.classList.contains('is-open')) panel.style.maxHeight = 'none';
      }, PANEL_TRANSITION_MS);

      toggle.setAttribute('aria-expanded', 'true');
      toggle.querySelector('[data-hc-label-open]').hidden = true;
      toggle.querySelector('[data-hc-label-close]').hidden = false;
    }

    function closeDrawer(drawer, overlay, trigger) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        drawer.hidden = true;
        overlay.hidden = true;
      }, 300);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function openDrawer(drawer, overlay, trigger) {
      overlay.hidden = false;
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    document.addEventListener('toggle', function (event) {
      var details = event.target;
      if (!details.matches || !details.matches('.hc-panel__details, .hc-drawer__details')) return;
      var plus = details.querySelector('.hc-panel__plus, .hc-drawer__plus');
      if (plus) plus.textContent = details.open ? '\u2212' : '+';

      var panel = details.closest('.hc-panel.is-open');
      if (panel && panel.style.maxHeight !== 'none') {
        requestAnimationFrame(function () {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      }
    }, true);

    document.addEventListener('click', function (event) {
      var panelTrigger = event.target.closest('[data-hc-panel-open]');
      if (panelTrigger) {
        var header = panelTrigger.closest('header-custom');
        var panel = header.querySelector('[data-hc-panel]');
        var isOpen = panelTrigger.getAttribute('aria-expanded') === 'true';
        closeAllPanels();
        if (!isOpen) openPanel(panel, panelTrigger);
        return;
      }

      var drawerOpenTrigger = event.target.closest('[data-hc-drawer-open]');
      if (drawerOpenTrigger) {
        var header2 = drawerOpenTrigger.closest('header-custom');
        var drawer = header2.querySelector('[data-hc-drawer]');
        var overlay = header2.querySelector('[data-hc-overlay]');
        openDrawer(drawer, overlay, drawerOpenTrigger);
        return;
      }

      var drawerCloseTrigger = event.target.closest('[data-hc-drawer-close]');
      var overlayClick = event.target.closest('[data-hc-overlay]');
      if (drawerCloseTrigger || overlayClick) {
        var drawerEl = document.querySelector('.hc-drawer.is-open');
        var overlayEl = document.querySelector('.hc-overlay:not([hidden])');
        var openTrigger = document.querySelector('[data-hc-drawer-open][aria-expanded="true"]');
        if (drawerEl && overlayEl) closeDrawer(drawerEl, overlayEl, openTrigger);
        return;
      }

      if (!event.target.closest('.hc-panel') && !event.target.closest('[data-hc-panel-open]')) {
        closeAllPanels();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAllPanels();
      var drawerEl = document.querySelector('.hc-drawer.is-open');
      var overlayEl = document.querySelector('.hc-overlay:not([hidden])');
      var openTrigger = document.querySelector('[data-hc-drawer-open][aria-expanded="true"]');
      if (drawerEl && overlayEl) closeDrawer(drawerEl, overlayEl, openTrigger);
    });
  })();

  // Transparent header scroll state — adds [data-scrolled] once the page
  // has scrolled a little, which is what flips the header background from
  // transparent to solid white (see the [transparent][data-scrolled] CSS
  // rule above).
  (function () {
    function updateHeaders() {
      document.querySelectorAll('.hc-header[transparent]').forEach(function (header) {
        if (window.scrollY > 30) {
          header.setAttribute('data-scrolled', '');
        } else {
          header.removeAttribute('data-scrolled');
        }
      });
    }

    window.addEventListener('scroll', updateHeaders, { passive: true });
    document.addEventListener('shopify:section:load', updateHeaders);
    window.addEventListener('DOMContentLoaded', updateHeaders);
    updateHeaders();
  })();

  // Sticky state tracking for header-custom (only relevant for
  // sticky="always" now that "scroll-up" has been removed), mirrors
  // header.js behavior for the default header so the
  // [sticky='always'] CSS rule can work.
  (function () {
    document.querySelectorAll('header-custom[sticky="always"]').forEach(function (header) {
      header.dataset.stickyState = 'idle';

      function update() {
        header.dataset.stickyState = window.scrollY > 0 ? 'active' : 'idle';
      }

      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
